import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import { scrollToElementById } from '@/module/utils';


@Component({components:{}})
export default class AlegereEveniment extends Vue {
    loading:boolean=false;
    evenimentMobilSlide='aniversare';

    $refs:any;
    private userStore=getModule(User);



    constructor(){
        super();
    }

    handleSwipePage ({ evt, ...info }:any) {
        let vueInst=this;
        if(info.direction=='up'){//prev Page
            scrollToElementById('div_alege_sa_te_implici',-20,300);
        }
        if(info.direction=='down'){//prev Page
            scrollToElementById('img_logo_site',0,300);
        }
        if(info.direction=='left'){//prev Page
            vueInst.$refs.carousel_alegere_eveniment.next();
        }
        if(info.direction=='right'){//prev Page
            vueInst.$refs.carousel_alegere_eveniment.previous ();
        }
    }

}
